<template>
    <!-- App Header -->
    <SideHeader :to="'/'" />
    <!-- * App Header -->

    <!-- App Capsule -->
    <div style="padding-top: 55px;">
        <ListView v-if="loading" />
        <div v-else class="section full mt-1 mb-2">
            <!-- Search -->
            <!-- <div class="section-title">خبرم کن!</div> -->
            <div class="wide-block pb-1">
                <div class="container">
                    <form @submit.prevent="storeData">
                        <!-- From -->
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="form-label fw-bold" for="from">مبدا</label>
                                <select required class="form-control form-select" id="from" v-model="postData.fromCity_id">
                                    <option value="">انتخاب کنید...</option>
                                    <option v-for="result in results" :key="result.id" :value="result.id">
                                        {{ result.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- To -->
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="form-label fw-bold" for="to">مقصد</label>
                                <select required class="form-control form-select" id="to" v-model="postData.toCity_id">
                                    <option value="">انتخاب کنید...</option>
                                    <option v-for="result in results" :key="result.id" :value="result.id">
                                        {{ result.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Date -->
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="form-label fw-bold mb-1" for="to">تاریخ</label>
                                <input type="text" class="form-control custom-input" placeholder="امروز" />

                                <date-picker color="#0EA47A" v-model="postData.date" format="YYYY-MM-DD"
                                    display-format="jYYYY-jMM-jDD" custom-input=".custom-input" />

                                <!-- <input type="text" class="form-control form-select"> -->
                                <!-- <select class="form-control form-select" id="to"
                                    v-model="postData.selectedDischargeCitiesIds">
                                    <option value="">انتخاب کنید...</option>
                                    <option v-for="result in results" :key="result.id" :value="result.id">
                                        {{ result.name }}
                                    </option>
                                </select> -->
                            </div>
                        </div>

                        <!-- Fleet -->
                        <div class="form-group basic" @click="backFleet">
                            <div class="input-wrapper">
                                <label class="form-label fw-bold">نوع ناوگان</label>
                                <span class="form-control form-select mt-1 text-start" data-bs-toggle="offcanvas"
                                    data-bs-target="#actionSheetForm">
                                    {{ selectedState }}
                                </span>
                            </div>
                        </div>

                        <!-- Search button -->
                        <div class="mt-2">
                            <button type="submit" class="btn background-ORANGE text-light btn-block btn-lg">
                                ثبت
                            </button>
                        </div>
                    </form>

                    <!-- Fleet Selection Offcanvas -->
                    <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" id="actionSheetForm">
                        <div class="offcanvas-header background-TEAL">
                            <h5 class="offcanvas-title text-light">انتخاب ناوگان</h5>
                        </div>
                        <div class="offcanvas-body">
                            <div class="form-group basic mb-5">
                                <div class="section full mt-2">
                                    <div class="section-title text-center">
                                        لطفا ناوگان مورد نظر خود را انتخاب کنید
                                    </div>

                                    <div class="accordion" id="accordionExample1">
                                        <div v-for="(group, index) in fleetGroups" :key="index" class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button"
                                                    :data-bs-target="'#accordion' + index" data-bs-toggle="collapse">
                                                    {{ group.title }}
                                                </button>
                                            </h2>
                                            <div :id="'accordion' + index" class="accordion-collapse collapse"
                                                data-bs-parent="#accordionExample1">
                                                <div class="accordion-body">
                                                    <div class="input-list">
                                                        <div class="form-check" v-for="fleet in fleets[group.key]"
                                                            :key="fleet.id">
                                                            <input class="form-check-input" type="radio"
                                                                name="radioList" :id="'radioList' + fleet.id"
                                                                :value="fleet.id" v-model="postData.fleet_id"
                                                                @click="changeTitleFleet(fleet.title)">
                                                            <label class="form-check-label"
                                                                :for="'radioList' + fleet.id">
                                                                {{ fleet.title }}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Confirm Fleet -->
                            <div class="form-group basic fixed bottom-0 w-full">
                                <button type="button" data-bs-dismiss="offcanvas"
                                    class="btn background-ORANGE text-light btn-block">
                                    ثبت
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- Search History -->
                    <!-- <div class="listview-title mt-1">تاریخچه</div> -->
                    
                    <div class="mt-2" v-if="histories.length != 0">
                        <p class="text-center" v-if="histories.length <= 0">دیتا یافت نشد</p>
                        <div v-else class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <!-- <th scope="col">#</th> -->
                                        <th scope="col">ناوگان</th>
                                        <th scope="col">مبدا</th>
                                        <th scope="col">مقصد</th>
                                        <th scope="col">تاریخ</th>
                                        <th scope="col">وضعیت</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(history, index) in histories" :key="index">
                                        <!-- <th scope="row">{{ index + 1 }}</th> -->
                                        <td>{{ history?.fleet?.title }}</td>
                                        <td>{{ history?.from_city?.name }}</td>
                                        <td>{{ history?.to_city?.name ?? 'همه' }}</td>
                                        <td>{{ history.date }}</td>
                                        <td :class="history.status == 1 ? 'text-success' : 'text-danger'">{{ history.status ? 'ارسال شد' : 'در حال بررسی' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- <ul v-else class="listview link-listview">
                            <li v-for="(history, index) in histories" :key="index">
                                <router-link
                                    :to="'/searchSelectCities?fleet_id=&selectedLoadingCitiesIds=' + history.from_city_id + '&selectedDischargeCitiesIds=' + history.to_city_id">
                                    {{ history?.from_city?.name }} به {{ history?.to_city?.name ?? 'همه' }}
                                </router-link>
                            </li>
                        </ul> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideHeader from '@/components/SideHeader.vue'
import axios from 'axios'
import Swal from 'sweetalert2'
import ListView from '@/components/Placeholder/ListView.vue'
import router from '@/router'
import DatePicker from 'vue3-persian-datetime-picker'
export default {
    components: {
        SideHeader,
        ListView,
        DatePicker
    },
    data() {
        return {
            histories: [],
            results: [],
            loading: false,
            selectedState: 'انتخاب کنید',
            postData: {
                fromCity_id: "",
                toCity_id: "",
                fleet_id: "",
                date: "",
            },
            fleets: { coms1: [], coms2: [], coms3: [], coms4: [], coms5: [] },
            axiosConfig: {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    Accept: 'application/json'
                }
            },
            fleetGroups: [
                { key: "coms5", title: "نیسان و وانت" },
                { key: "coms1", title: "کامیونت" },
                { key: "coms2", title: "کامیون 6 چرخ (تک)" },
                { key: "coms3", title: "کامیون 10 چرخ (جفت)" },
                { key: "coms4", title: "تریلی" },
            ]
        }
    },
    methods: {
        storeData() {
            axios.post("https://core.iran-tarabar.ir/api/driver/aware", this.postData, this.axiosConfig)
                .then((res) => {
                    Swal.fire({
                        icon: "success",
                        position: "center",
                        title: "راننده گرامی",
                        text: res.data.message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                    this.getAwares();
                })
                .catch((error) => {
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "راننده گرامی",
                        text: error.response.data.message,
                        showConfirmButton: false,
                        timer: 2000
                    });

                    // handle error
                    // console.log(error.response.data.message);
                });
            // console.log(this.postData);
        },

        changeTitleFleet(value) {
            this.selectedState = value
        },
        async getAwares() {
            try {
                const { data } = await axios.get("https://core.iran-tarabar.ir/api/driver/aware", this.axiosConfig)
                this.histories = data.data
            } catch (err) {
                // Swal.fire({
                //     position: "center",
                //     icon: "error",
                //     title: "لطفا اینترنت خود را بررسی کنید",
                //     showConfirmButton: true,
                //     confirmButtonText: "تایید",
                // })
            }
        },

        async getFleets() {
            try {
                const { data } = await axios.get("https://core.iran-tarabar.ir/api/customer/requestAllFleetsLists")
                const mapping = { 42: "coms1", 43: "coms2", 53: "coms3", 54: "coms4", 81: "coms5" }
                data.fleets.forEach(f => {
                    const key = mapping[f.parent_id]
                    if (key) this.fleets[key].push(f)
                })
            } catch {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "لطفا اینترنت خود را بررسی کنید",
                    showConfirmButton: true,
                    confirmButtonText: "تایید",
                })
            }
        },
        async cities() {
            try {
                const { data } = await axios.get("https://core.iran-tarabar.ir/api/driver/v2/provinceAndCitiesList", this.axiosConfig)
                this.results = data.data.provinces
            } catch {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "لطفا اینترنت خود را بررسی کنید",
                    showConfirmButton: true,
                    confirmButtonText: "تایید",
                })
            }
        },
        async fleetDefault() {
            try {
                const { data } = await axios.get("https://core.iran-tarabar.ir/api/driver/fleetDefault", this.axiosConfig)
                this.selectedState = data.title + " (پیش فرض) "
                this.postData.fleet_id = data.id
            } catch (error) {
                if (error.response?.status === 401) {
                    Swal.fire({
                        title: "راننده محترم!",
                        text: "شماره ای که با آن وارد برنامه شده اید، توسط دستگاه دیگری مورد استفاده قرار گرفته است!",
                        icon: "error",
                        confirmButtonColor: "#068b80",
                        confirmButtonText: "ورود مجدد!",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            localStorage.clear()
                            router.push({ name: 'login' })
                        }
                    })
                }
            }
        },
        backFleet() {
            if (history.pushState) {
                const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?backFleet=1`
                window.history.pushState({ path: newurl }, '', newurl)
            }
        }
    },
    async mounted() {
        localStorage.removeItem('scrollPosition')
        await Promise.all([this.cities(), this.fleetDefault(), this.getFleets(), this.getAwares()])
    }
}
</script>

<style scoped>
.link-listview>li {
    border-bottom: 1px solid #e5e5e5;
}
</style>